export function notFoundInMutator(): string {
  return 'Not found';
}
